import React from 'react';
import { Box, Container, VStack, Heading, Text, Button, Image, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import ContactButton from '../utils/ContactButton.jsx';

const Success = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="white">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        {/* Section de succès avec design iOS */}
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="linear-gradient(135deg, #094c26 0%, #0d6b35 50%, #063a1d 100%)"
          py={{ base: 16, lg: 20 }}
        >
          <Container maxW="1200px" px={5}>
            <VStack spacing={8} textAlign="center" color="white">

              {/* Titre principal */}
              <Heading 
                as="h1" 
                size={{ base: "xl", md: "2xl" }} 
                fontWeight={800}
                textAlign="center"
                maxW="600px"
              >
                🌱 Devis demandé avec succès !
              </Heading>

              {/* Message de confirmation */}
              <VStack spacing={4} maxW="600px">
                <Text fontSize={{ base: "lg", md: "xl" }} fontWeight={600} textAlign="center">
                  Merci pour votre intérêt pour nos solutions énergétiques !
                </Text>
                <Text fontSize={{ base: "md", md: "lg" }} opacity={0.9} textAlign="center">
                  Un expert Groupe Solarenov analysera votre projet et vous rappellera rapidement pour vous proposer la meilleure solution solaire.
                </Text>
                <Text fontSize={{ base: "sm", md: "md" }} opacity={0.8} textAlign="center">
                  ⏰ Rappel garanti sous 24 heures ouvrées
                </Text>
              </VStack>

              {/* Informations importantes */}
              <Box
                bg="rgba(255, 255, 255, 0.15)"
                borderRadius="2xl"
                p={{ base: 6, md: 8 }}
                backdropFilter="blur(10px)"
                border="1px solid"
                borderColor="whiteAlpha.300"
                maxW="600px"
                w="100%"
              >
                <VStack spacing={3} align="start">
                  <Heading as="h2" size="sm" fontWeight={700} textAlign="center" w="100%">
                    🏠 Prochaines étapes
                  </Heading>
                  <VStack spacing={2} align="start" w="100%">
                    <Text fontSize={{ base: "sm", md: "md" }}>
                      • Diagnostic énergétique gratuit de votre logement
                    </Text>
                    <Text fontSize={{ base: "sm", md: "md" }}>
                      • Devis personnalisé avec optimisation des aides
                    </Text>
                    <Text fontSize={{ base: "sm", md: "md" }}>
                      • Accompagnement dans vos démarches administratives
                    </Text>
                    <Text fontSize={{ base: "sm", md: "md" }}>
                      • Installation par nos artisans RGE certifiés
                    </Text>
                  </VStack>
                </VStack>
              </Box>

              {/* Boutons d'action */}
              <HStack spacing={4} flexDirection={{ base: "column", md: "row" }}>
                <Button
                  onClick={handleGoHome}
                  bg="white"
                  color="#094c26"
                  size="lg"
                  px={8}
                  py={6}
                  borderRadius="xl"
                  fontWeight={700}
                  fontSize={{ base: "md", md: "lg" }}
                  _hover={{
                    bg: "rgba(255, 255, 255, 0.9)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                  }}
                  transition="all 0.3s ease"
                  boxShadow="0 8px 20px rgba(0,0,0,0.1)"
                >
                  🏠 Retour à l'accueil
                </Button>
                <ContactButton 
                  size="lg"
                  px={8}
                  py={6}
                  fontSize={{ base: "md", md: "lg" }}
                  fontWeight={700}
                />
              </HStack>

            </VStack>
          </Container>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default Success;
